import { createIcon } from "@chakra-ui/react";

const Dot02SIcon = createIcon({
  displayName: "Dot02SIcon",
  viewBox: "0 0 24 24",
  path: <path d="M12 15a3 3 0 1 1 0-6a3 3 0 0 1 0 6Z" fill="currentColor" />,
});

export default Dot02SIcon;
